import moment from 'moment';
import { defaultDirection } from '../constants/defaultValues';

export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    var A = a[key],
      B = b[key];
    if (order.indexOf(A + '') > order.indexOf(B + '')) {
      return 1;
    } else {
      return -1;
    }
  });
  return array;
};

export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; //January is 0!

  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  return dd + '.' + mm + '.' + yyyy;
};

export const getCurrentTime = () => {
  const now = new Date();
  return now.getHours() + ':' + now.getMinutes();
};

export const getDirection = () => {
  let direction = defaultDirection;
  if (localStorage.getItem('direction')) {
    const localValue = localStorage.getItem('direction');
    if (localValue === 'rtl' || localValue === 'ltr') {
      direction = localValue;
    }
  }
  return {
    direction,
    isRtl: direction === 'rtl',
  };
};

export const setDirection = (localValue) => {
  let direction = 'ltr';
  if (localValue === 'rtl' || localValue === 'ltr') {
    direction = localValue;
  }
  localStorage.setItem('direction', direction);
};

export const reactSelectOption = (options, isDefault) => {
  let option = options.map((option) => ({
    value: option.id,
    label: option.name,
  }));
  if (isDefault) {
    option = [{ value: '-1', label: 'All' }, ...option];
  }
  return option;
};

export const reactSelectOptionDiffrentPro = (
  options,
  isDefault,
  key,
  value,
  defaultLabel
) => {
  let option = options.map((option) => ({
    value: option[key],
    label: option[value],
  }));
  // if (isDefault) {
  //   option = [{ value: '-1', label: defaultLabel }, ...option];
  // }
  return option;
};

export const reactSelectProperties = (
  options,
  isDefault,
  key,
  value,
  secondKey
) => {
  let lst = [];
  options.map((option) => {
    if (
      option[secondKey] !== undefined &&
      option[secondKey] !== null &&
      option[secondKey] !== ''
    ) {
      lst.push({
        value: option[key] + '|' + option[secondKey],
        label: option[value],
      });
    } else {
      lst.push({ value: option[key], label: option[value] });
      return option;
    }
  });
  return lst;
};
export const reactSelectOptionDiffrentProWithKeyValue = (
  options,
  isDefault,
  key,
  value,
  defaultLabel
) => {
  let option = options.map((option) => ({
    value: option[key],
    label: option[value],
  }));
  // if (isDefault) {
  //   option = [{ value: '-1', label: defaultLabel }, ...option];
  // }
  return option;
};

export function joinClassNames(classNames) {
  return classNames.filter(Boolean).join(' ');
}

export const sortPropertyListByName = (list) => {
  return list
    .sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    })
    .sort((a, b) => a.name - b.name);
};

export const getPageUrlName = (integration) => {
  switch (integration.channel) {
    case 'WebsiteDirectLine':
      return 'integrationdetail';
    case 'WhatsApp':
      return 'whatsapp-detail';
    case 'FacebookDirectLine':
      return 'facebookdetail';
    case 'TeamsApp':
      return 'teams-integrationdetail';
    case 'WeChat':
      return 'wechat-detail';
    case 'Sms':
      return 'sms-detail';
    case 'PhoneSuite':
      return 'phone-suite-detail';
    case 'EmailAssistant':
    case 'EmailDirectLine':
      return 'email-integrationdetail';
    default:
      return '';
  }
};

export const addOneDay = (dateStr) => {
  return moment(dateStr, 'YYYY-MM-DD HH:mm:ss')
    .add(1, 'day')
    .format('YYYY-MM-DD HH:mm:ss');
};
